// Test hooks for the child components that need to be specifically addressed with a test id
export const TestHooks = {
	BrokerSearchAutoComplete: 'broker-search-auto-complete',
	CreateAgentButton: 'create-agent-button',
	MemberCard: 'member-card',
	BrokerItemDiv: 'broker-item-div',
} as const;
